// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"b5d5506f","284":"555eeb01","577":"77c9ad3a","901":"b2a2a9f8","906":"ea0affab","945":"bf3c47b0"}[chunkId] + ".chunk.css";
};